module.exports = __webpack_public_path__ + "img/2-logo_topbar+footer_mobile.0f5a3436.png";